import { Button } from "@/components/ui/button";
import React from "react";
import { Link } from "react-router-dom";

function NavigationButton({
	url,
	title,
	isActive,
	icon,
}: {
	url: string;
	title: string;
	isActive: boolean;
	icon: React.ReactElement;
}) {
	return isActive ? (
		<Button className="flex flex-row gap-4 text-left">
			{icon}
			<Link to={url}>{title}</Link>
		</Button>
	) : (
		<Link to={url} className="flex flex-row gap-4 p-4 text-left">
			{icon}
			{title}
		</Link>
	);
}

export default NavigationButton;
